<div class="app-modal-title">
	<div class="title">Data Preview</div>
	<div class="close-icon">
		<i class="glyphicons glyphicons-remove" (click)="dialogRef.close(null)"></i>
	</div>
</div>
<div class="app-modal-content">
	<app-common-datagrid
		#table
		class="material"
		[columnMode]="'force'"					
		[rows]="previewRows"
		[columns]="previewColumns"
		[selectionType]="'single'"
		[totalNum]="previewRows.length"
	></app-common-datagrid>
</div>